import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppPaginationComponent } from "./pagination.component";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  declarations: [AppPaginationComponent],
  imports: [
    CommonModule,
    PaginationModule,
    FormsModule,
    BsDropdownModule.forRoot()
  ],
  exports: [AppPaginationComponent]
})
export class AppPaginationModule { }
